import React, { useState, useEffect, useMemo } from "react";
import { Grid, Box, MenuItem, ListItemIcon, Container, List, Typography, ListItem, ListItemText } from '@mui/material';
import { UrlApi } from '../../../../services/apirest';
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import DeleteIcon from '@mui/icons-material/Delete';
import Modalquitarpedido from './Modalquitarpedido';
import moment from "moment";
import DialogEntregado from "../../../referencias-tablas/pedidos/DialogEntregado";
import { Edit, Preview } from "@mui/icons-material";
import DialogConTextField from "../../../Dialogs/DialogConTextField";
import { putData } from "../../../../services/library";
import Notify from "../../../Notify";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ModalEditar from "../crearRepartos/ModalEditar";
import ModalEditar2 from "../crearRepartos/ModalEditar2";

import { getData } from "../../../../services/library";
import DetailPanelPedido from "./DetailPanelPedido";
import DialogObservacionesPedido from "../crearRepartos/DialogObservacionesPedido";

export default function VerDatosRep(props) {
    const [datos, setDatos] = useState(props.datos);
    const [pedidos, setPedidos] = useState();
    const [openPedidos, setopenPedidos] = useState(false);
    const [eliminarPedido, seteliminarPedidos] = useState(false)
    const [datosPedidos, setDatosPedidos] = useState({});
    const [openObservaciones, setopenObservaciones] = useState(false);
    const [observaciones, setObs] = useState("");
    const [editar, setEditar] = useState(false);
    const iconRemove = <RemoveCircleOutlineIcon sx={{ fontSize: 40 }} />;
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const obtenerPedidos = () => {
        fetch(UrlApi + '/pedidos/reparto/' + datos.nro_reparto)
            .then(data => data.json())
            .then(data => setPedidos(data))
    };

    useEffect(() => {
        obtenerPedidos()
    }, []);

    useEffect(()=>{
        if(props.pedidosdelreparto) obtenerPedidos()
    },[props.pedidosdelreparto])

    const openEditar = (datos) => {
        setEditar(true)
        setDatosPedidos(datos)
    };

    const openModalEliminar = (datos) => {
        seteliminarPedidos(true)
        setDatosPedidos(datos)
    };

    const columns = useMemo(() =>
        // [{ header: '   #', accessorKey: 'id', size: '50', enableEditing: false, },
        [{
            header: 'Razón Social',
            size: '200',
            accessorFn: (c) =>
                `(${c?.sisven_id ?? ""}) ${c.razon_social} (${c.empresa})`, enableEditing: false
        },
        { header: 'CUIT/DNI', accessorKey: 'cuit', enableEditing: false, size: '110' },
        // { header: 'Situación iva', accessorKey: 'condicion_iva', enableEditing: false },
        { header: 'Dirección de entrega', accessorFn: (d) => `${d.nombre_direccion} (${d.direccion_entrega})`, enableEditing: false },
        { header: 'Localidad', accessorKey: 'localidad', enableEditing: false, size: '150' },
        { header: 'Kg a cargar', accessorKey: 'kgacargar', enableEditing: false, size: '110' },
        // { header: 'Registrado',  accessorFn: (reg) => moment(reg.registrado).format("DD-MM-YYYY"), enableEditing: false, size: '110' },
        { header: 'Estado', accessorKey: 'estado', enableEditing: false, size: '110' },
        { header: 'Orden', accessorKey: 'orden_prioridad', type: "number", size: '50', enableEditing: (row) => row.original.id_estado === 23 },
        ], []);

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 14,
            color: "black",
            fontWeight: "normal",
            paddingTop: 1,
            paddingBottom: 1,
            backgroundColor: "#D4E6F1",
            borderColor: "#FDFEFE",
        },
    };

    const rowBg = {
        19: "#FFFFFF",
        20: "#FEF5E7", //revisado -> natural
        21: "#ABEBC6", //aprobado -> verde clarito
        22: "#DC7633", //rechazado -> rojo
        23: "#85C1E9", //asignado -> celestito
        41: "#DC7633", //entregado
        25: "#D7BDE2", //Facturado -> violeta
        32: "#EC7063", //CANCELADO -> BORDÓ
    };

    const editarOrden = async ({ exitEditingMode, row, values }) => {
        let response = await fetch(UrlApi + '/pedidos/' + row.original.id, {
            method: 'PUT',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                orden_prioridad: values.orden_prioridad
            })
        })
        props.actualizar()
        obtenerPedidos()
        
        exitEditingMode()
    };


    const handleClose = () => {
        setopenObservaciones(false)
        obtenerPedidos()

    };

    const initialState = {
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 }
    };


    //ACA TENGO QUE OBTENER LAS OBSERVACIONES Y PASARSELAS COMO PARAMETRO AL DETAIL PANEL.
    //CUANDO CIERRO EL MODAL DE OBSERVACIONES, TENGO QUE EJECUTAR LA FUNCION PARA OBTENER LAS OBSERVACIONES

    const [updateData, setUpdateData]=useState();

    return (
        <div >
            {pedidos &&
                <Box boxShadow={3} sx={{ margin: "auto" }}>
                    <MaterialReactTable
                        editingMode="row"
                        enableColumnResizing
                        columns={columns}
                        initialState={initialState}
                        data={pedidos}
                        layoutMode="semantic"
                        enableEditing={row => row.id_estado !== 23}
                        enableRowActions
                        positionActionsColumn='last'
                        muiTableHeadCellProps={tableHeadCellProps}
                        localization={MRT_Localization_ES}
                        muiTableBodyCellProps={({ row }) => ({
                            align: "left",
                            sx: {
                                backgroundColor:
                                    rowBg[row.original.id_estado] ?? "#fff",
                                color: "black",
                                borderColor: "black",
                            },
                        })}
                        enableColumnActions={false}
                        renderRowActionMenuItems={({ closeMenu, row }) => {
                            const isSector12 = parseInt(localStorage.getItem('sector')) === 12;
                            return [
                                <MenuItem
                                    disabled={row.original.id_estado !== 23 || !isSector12}
                                    key={1}
                                    onClick={() => {
                                        openModalEliminar(row.original)
                                        closeMenu();
                                    }}
                                    sx={{ m: 0 }}
                                >
                                    <ListItemIcon>
                                        <DeleteIcon color="error" />
                                    </ListItemIcon>
                                    Quitar pedido del reparto
                                </MenuItem>,
                                <MenuItem
                                    disabled={!isSector12}
                                    key={2}
                                    onClick={()=>{
                                        setDatosPedidos(row.original)
                                        setopenObservaciones(true)
                                        closeMenu()
                                    }}
                                    sx={{ m: 0 }}
                                >
                                    <ListItemIcon>
                                        <Preview color="secondary" />
                                    </ListItemIcon>
                                    Observaciones
                                </MenuItem>,
                                <MenuItem
                                    disabled={row.original.id_estado !== 23 || !isSector12}
                                    key={1}
                                    onClick={() => {
                                        openEditar(row.original)
                                        closeMenu();
                                    }}
                                    sx={{ m: 0 }}
                                >
                                    <ListItemIcon>
                                        <Edit color="primary" />
                                    </ListItemIcon>
                                    Editar
                                </MenuItem>,
                            ]
                        }}
                        enableColumnFilters={false}
                        enableColumnDragging={false}
                        enableHiding={false}
                        enableTopToolbar={false}
                        enablePagination={false}
                        enableBottomToolbar={false}
                        onEditingRowSave={editarOrden}
                        renderDetailPanel={({ row }) => <DetailPanelPedido row={row} updateData={updateData} setUpdateData={setUpdateData} />}
                    />
                </Box>
            }
            {
                openObservaciones && (
                    <>
                        <DialogObservacionesPedido
                            open={openObservaciones}
                            setOpen={setopenObservaciones}
                            pedido={{ ...datosPedidos, idpedido: datosPedidos.id }}
                            handleClose={() => {
                                setopenObservaciones(false)
                                setUpdateData(true);
                            }}
                        />
                    </>
                )
            }
            {
                openPedidos ? (
                    <DialogEntregado
                        pedido={datosPedidos}
                        open={openPedidos}
                        setOpen={setopenPedidos}
                        actualizar={obtenerPedidos}
                    />
                ) : null
            }
            {eliminarPedido ? (
                <Modalquitarpedido actualizar={obtenerPedidos} datos={datosPedidos} open={seteliminarPedidos} />
            ) : null}

            {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={handleClose}
                    severity={notificacion.severity}
                />
            ) : null}

            {editar ?
                <ModalEditar2
                    open={editar}
                    datos={datosPedidos}
                    setOpen={setEditar}
                    getPedidos={obtenerPedidos}
                    refreshRepartos={props.actualizar}
                    vengo={1}
                    tabla={props.tabla}>
                        

                </ModalEditar2>
                : null}

        </div>
    )
}
